
namespace SorAraBul.Definitions {
    export class CountriesColumns {
        static columnsKey = 'Definitions.Countries';
    }
}